import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { SubjectLineMatchType } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import * as React from "react";
import {
  ConditionType,
  ConditionTypeDetailsProps,
} from "../../return-flow/condition";
import { displayStringForMatchCondition } from "../rule-utils";

export type MessageBodyMatchesState = Omit<
  Condition.MessageBodyMatches,
  "type"
>;

export const MESSAGE_BODY_MATCHES = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<MessageBodyMatchesState>
  >,
): ConditionType<MessageBodyMatchesState, Condition.MessageBodyMatches> => ({
  name: CONDITION_NAMES[Condition.MESSAGE_BODY_MATCHES],
  description(state) {
    return displayStringForMatchCondition(
      "Message body",
      state.matchMode === "INCLUDES"
        ? SubjectLineMatchType.CONTAINS
        : SubjectLineMatchType.EXACT,
      state.queryStrings,
    );
  },
  Details(props: ConditionTypeDetailsProps<MessageBodyMatchesState>) {
    return React.createElement(Details, props);
  },
  empty: { queryString: "", caseSensitive: false, matchMode: "INCLUDES" },
  fromModel(model) {
    return {
      queryStrings: model.queryStrings || [model.queryString || ""],
      caseSensitive: model.caseSensitive,
      matchMode: model.matchMode,
    };
  },
  toModel(state) {
    return { type: Condition.MESSAGE_BODY_MATCHES, ...state };
  },
  valid(state) {
    return (state.queryStrings?.length || 0) > 0;
  },
});
